<template>
  <span>
    <v-tooltip v-if="aliasNotFound && !showCustomName" color="tooltip" bottom>
      <template v-slot:activator="{ on }">
        <v-icon v-on="on" left color="#545454" class="mr-2">
          mdi-label-off
        </v-icon>
      </template>
      <p class="ma-0 pa-0 label-off-tooltip">
        {{ $t('alias_not_found') }}
      </p>
    </v-tooltip>
    {{ displayName }}
  </span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EMTagDisplay',
  props: {
    tagName: {
      type: String,
      required: true,
    },
    tagAlias: {
      type: String,
      required: false,
      default: null,
    },
    customName: {
      type: String,
      required: false,
      default: null,
    },
    showCustomName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['getIsTechnicalTagLabel']),
    displayName() {
      if (this.showCustomName && this.customName) {
        return this.customName.trim();
      }
      if (!this.getIsTechnicalTagLabel && this.tagAlias?.trim()) {
        return this.tagAlias;
      }
      return this.tagName;
    },
    aliasNotFound() {
      return (this.tagAlias === '' || this.tagAlias === null || this.tagAlias === undefined) && !this.getIsTechnicalTagLabel;
    },
  },
};
</script>

<style scoped>
.label-off-tooltip {
  color: #000000 !important;
  font-weight: 500;
}
</style>
